// extracted by mini-css-extract-plugin
module.exports = {"arrow-btn-box":"bg","arrowBtnBox":"bg","arrow-btn-wrap-box":"bh","arrowBtnWrapBox":"bh","arrow-btn-text":"bi","arrowBtnText":"bi","arrow-btn-arrow":"bj","arrowBtnArrow":"bj"};